import { BaseStore } from "@deputy-ai/common/jotai";
import { atom, type PrimitiveAtom } from "jotai";
import { createTranslator } from "next-intl";

type Params = Parameters<typeof createTranslator>[0];

export interface I18nStoreOptions {
  locale: string;
  messages: Record<string, any>;
}
export class I18nStore extends BaseStore {
  locale: PrimitiveAtom<string>;
  messages: PrimitiveAtom<Record<string, any>>;

  constructor(options: I18nStoreOptions) {
    super();

    this.locale = atom(options.locale);
    this.messages = atom(options.messages);
  }

  setContext(locale: string, messages: Record<string, any>) {
    this.set(this.locale, locale);
    this.set(this.messages, messages);
  }

  createTranslatorAtom(namespace?: string, params?: Params) {
    return atom((get) => {
      const locale = get(this.locale);
      const messages = get(this.messages);

      return createTranslator({
        locale,
        messages,
        namespace,
      });
    });
  }
}
